






















































































import { Component, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { SwDropMenu, DropMenuItem } from '@libs-uuif/shared/sw-drop-menu';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { SwExpandableTextfield, SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwTable, TableEntry, TableColumnConfig, ColumnsAdjustRequestData, SortedColumnInfo, ColumnSortRequestData } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { MswApiService } from '@/shared/msw-api-service';
import { InfoState } from '@/core';
import { MswAppTitle }  from '@/shared/msw-app-title';
import { CreateElement } from 'vue';
import { VNode } from 'vue/types/umd';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import ExportcsvService from '@/shared/msw-exportcsv.service';

const cssPrefix = 'snbPromotionsHistory';

@Component({
  components: {
    ...UUIFComponent,
    SwDropMenu,
    SwIconButton,
    SwExpandableTextfield,
    SwTextfield,
    SwTable,
    MswAppTitle,
  },
  directives: {},
})

export default class SandboxFallBackComponent extends SwExtendedVue {
  cssPrefix = cssPrefix;
  mainTableData: TableEntry[] = [];
  filtered: TableEntry[] = [];
  tableConfig: TableColumnConfig[] = [];
  menuOpened: boolean = false;
  exportMenuOpened: boolean = false;
  exportMenuItems: DropMenuItem[] = [
    { id: 'csv', content: 'Export CSV' },
    { id: 'xls', content: 'Export XLS' },
  ];
  apiResponse: any = '';
  filterItems: DropMenuItem[] = [];
  selectedMenuItem: string = '';
  searchValue: any = '';
  search: any = '';
  textExpanded : boolean = false;
  tableData : TableEntry[] = [];

  filterSearchKeys: any = [];
  filterSearch: string = '';
  searchInputChips: any[] = [];
  filterSearchConfig: any = {
    isEnableFilterSearch: false,
    filterSearchKey:'',
    filterSearchOption:'',
    filterSearchLabel:'',
  };
  globalSearchConfig: any = {
    isGlobalSearch: false,
    globalSearchKey: '',
  };
  globalSearchValue : string = '';
  columnSearchValue : string = '';
  adjustedColumns: ColumnsAdjustRequestData = {};
  filterColumnKey: string = '';
  filterColumnValue: string = '';
  sortedColumns: SortedColumnInfo[] = [];

  @Watch('search')
  whenSearchEmpty() {
    if (this.search === '') {
      this.filtered = this.mainTableData;
    }
  }

  onRequestAdjustColumns(data: ColumnsAdjustRequestData) {
    this.adjustedColumns = data;
  }

  onRequestSorting(data: ColumnSortRequestData) {
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  getUpgradeDetailsFromServer() {
    const id = this.$route.query.data;
    this.$store.commit('startLoading');
    MswApiService.promotions.getUpgradeDetails(id)
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'NOK') {
        return this.showMessage('failed', resp.msgDesc);
      }
      this.apiResponse = resp.content;
      this.makeTableHeaders();
      this.makeTableData();
      this.makeMenuItems();
    });
  }

  makeTableHeaders() {
    const dataHeaders = this.apiResponse.upgradeDetialsHeader.map((el: any) => {
      this.filterSearchKeys.push(el.dataIn);
      return {
        key: el.dataIn,
        dataKey: el.dataIn,
        title: el.ColHeader,
        sorter: true,
        /* tslint:disable-next-line */
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          {
            return (
              <div
                style={{ display: 'flex', flex: '1', alignItems: 'center' }}
                on-mouseover={() => {
                  this.filterColumnKey = data.entry._key;
                  this.filterColumnValue = data.entry[el.dataIn];
                }}
                on-mouseleave={() => (this.filterColumnKey = '')}
              >
                { data.entry[el.dataIn] }
                {this.filterColumnKey === data.entry._key &&
                  this.filterColumnValue === data.entry[el.dataIn] && (
                    <SwIcon
                      name="filter"
                      size={12}
                      style={{ marginLeft: '5px' }}
                      v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                      nativeOn-click={() => {
                        this.columnSearchValue = data.entry[el.dataIn];
                        this.filterByEachRow(el.dataIn);
                      }}
                    ></SwIcon>
                  )}
              </div>
            ) as VNode;
          }
        },
      };
    });
    this.tableConfig = dataHeaders;
  }

  makeTableData() {
    this.tableData = this.apiResponse.upgradeDetials.map((el: any, index: any) => {
      return {
        _key: index + 1,
        ...el,
      };
    });
    this.mainTableData = this.tableData;
  }

  makeMenuItems() {
    const filterItems = this.apiResponse.upgradeDetialsHeader.map((el: any) => {
      return {
        id: el.dataIn,
        content: el.ColHeader,
      };
    });
    this.filterItems = filterItems;
  }

  // Filter Implementation starts
  onSelectMultiItem(type: any) {
    this.menuOpened = !this.menuOpened;
    this.globalSearchValue = '';
    const isExistingChip = this.searchInputChips?.find((el: any) => el.column === type);
    if (!isExistingChip) {
      this.filterSearchConfig.isEnableFilterSearch = true;
      this.filterSearchConfig.filterSearchOption = type;
      this.filterSearchConfig.filterSearchLabel = this.filterItems.filter(ele => ele.id.toString() === type)[0].content;
    }
  }

  filterByEachRow(type: any) {
    this.globalSearchValue = '';
    if (this.columnSearchValue) {
      const isExistingChip = this.searchInputChips?.find((el: any) => el.column === type);
      if (!isExistingChip) {
        this.searchInputChips.push({ value: this.columnSearchValue.trim(), column: type });
      }
      this.applyAllFilters();
    }
  }

  handleSearchFilter() {
    this.applyAllFilters();
  }

  removeInputChip(index: any) {
    this.searchInputChips.splice(index, 1);
    this.applyAllFilters();
  }

  addFilterKey(event: any) {
    if (event.code === 'Enter' && this.filterSearchConfig.filterSearchKey !== '') {
      this.searchInputChips.push({ value: this.filterSearchConfig.filterSearchKey.trim(), column: this.filterSearchConfig.filterSearchOption });
      this.applyAllFilters();
      this.filterSearchConfig.filterSearchKey = '';
      this.filterSearchConfig.filterSearchLabel = '';
      this.filterSearchConfig.isEnableFilterSearch = false;
    }
  }

  applyAllFilters() {
    const data: any[] = [...this.mainTableData];
    let filteredData : any[] = [];
    this.$store.commit('startLoading');
    if (this.globalSearchValue) {
      this.filterItems.forEach((column: any) => {
        filteredData.push(...data.filter((element: any) => {
          return element[column.id].indexOf(this.globalSearchValue) > -1;
        }));
      });
    } else {
      if (this.searchInputChips.length === 0) {
        this.tableData = [...data];
        this.$store.commit('stopLoading');
        return;
      }
      filteredData = data.filter((item) => {
        for (const filter of this.searchInputChips) {
          if (item[filter.column] !== filter.value) {
            return false;
          }
        }
        return true;
      });
    }
    this.tableData = [...filteredData];
    this.$store.commit('stopLoading');
  }

  onRemoveAllFilters() {
    this.globalSearchValue = '';
    this.columnSearchValue = '';
    this.filterSearchConfig = {
      isEnableFilterSearch: false,
      filterSearchKey:'',
      filterSearchOption:'',
      filterSearchLabel:'',
    };
    this.searchInputChips = [];
    this.applyAllFilters();
  }
  // Filter Implementation ends

  refreshRecords() {
    this.onRemoveAllFilters();
    this.getUpgradeDetailsFromServer();
  }

  mounted() {
    this.getUpgradeDetailsFromServer();
  }

  showMessage(infoType: string, infoMsg: string) {
    // success and failed
    const message: InfoState = { infoType, infoMsg };
    this.$store.commit('displayMessage', message);
  }

  onChangeExport(itemId: string) {
    if (itemId === 'csv') {
      this.exportCsv();
    } else {
      this.exportXls();
    }
  }

  exportXls() {
    const XLSX = require('xlsx');
    const dataToExport = this.mapDataForExport(this.tableData, true);
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_json(ws, dataToExport, {
      origin: 'A1',
      skipHeader: false,
      cellDates: true,
      dateNF: 'MMM DD yyyy',
    });
    XLSX.utils.book_append_sheet(wb, ws, 'Issues');
    XLSX.writeFile(wb, 'PromotionsHistory.xlsx');
  }

  mapDataForExport(csvData: any[], isXls: any) {
    const filterJson: any = [];
    const itemHeader: any = [];
    this.tableConfig.map((ele: any) => {
      if (ele.dataKey !== undefined) {
        itemHeader.push(ele.title);
      }
    });
    !isXls && filterJson.unshift(itemHeader);
    csvData.map((dataItem:any) => {
      const obj = {};
      this.tableConfig.forEach((item) => {
        // // @ts-ignore
        if (item.dataKey && item.dataKey !== 'actions') {
          // @ts-ignore
          obj[item.title] = dataItem[item.dataKey]?.toString();
        }
      });
      filterJson.push(obj);
    });
    return filterJson;
  }

  startExport(productsList:any, name:string) {
    const XLSX = require('xlsx');
    const link = document.createElement('a');
    if (name.includes('.xls')) {
      const excel = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(productsList);
      ws['!autofilter'] = { ref: ws['!ref'] };
      XLSX.utils.book_append_sheet(excel, ws, 'Report');
      const finalExel = XLSX.writeFile(excel, name.concat('x'));
      const blobOb = new Blob(finalExel, { type: 'text/xls;charset=utf-8;' });
      link.href = URL.createObjectURL(blobOb);
      link.setAttribute('style', 'font-weight: bold');
      link.download = name.concat('x');
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  exportCsv() {
    ExportcsvService.export(this.mapToExport(this.tableData), 'PromotionsHistory.csv');
  }

  mapToExport(csvData: any[]) {
    let filterJson: any[] = [];
    const itemHeader: string[] = [];
    this.tableConfig.map((entry: TableColumnConfig) => {
      if (entry.key !== 'index' && typeof entry.title === 'string') {
        itemHeader.push(entry.title.toUpperCase());
      }
    });
    const tempJson: any = [{}, itemHeader];
    csvData.map((dataItem:any) => {
      const obj = {};
      this.tableConfig.forEach((item) => {
        if (item.dataKey) {
          // @ts-ignore
          obj[item.title] = dataItem[item.dataKey];
        }
      });
      tempJson.push(obj);
    });
    filterJson = filterJson.concat(tempJson);
    return filterJson;
  }
}
